// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__Sa1+M","nav__list":"Navbar_nav__list__jP0Xp","nav__link":"Navbar_nav__link__AidNu"};